exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#page-actueel-thema{display:inline-block}#page-actueel-thema .page__section{opacity:0;margin-bottom:25px}#page-actueel-thema .page-next-button{margin-top:-30px}.leraren-tekort{padding:0 20%}.leraren-tekort .flipper__face img{height:70px}.leraren-tekort .flipper{margin-bottom:0}.page-actueel-thema__footsteps{width:50px;transform:rotate(90deg);opacity:0}#page-actueel-thema__toekomst{position:relative;overflow:hidden}.page-actueel-thema__rocket{transform:rotate(56deg) scale(.6);top:-50px;left:calc(-50% - 100px);transition:left .5s;position:relative;visibility:hidden}.page-actueel-thema__rocket--ready-for-launch{visibility:visible}.page-actueel-thema__rocket--launch{left:0}.page-actueel-thema__next-btn{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-274ac50b","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-actueel-thema.vue
// module id = 52
// module chunks = 0